import { StatePropertyRef } from '../../canvas/ExtendableStore';

export const SelectedVoteRound = StatePropertyRef<string>('selectedVoteRound', '');
